<template>
  <b-modal
    id="edit-evacuation-diagram-modal"
    title="Evacuation Diagram Edit Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :onModalShow="modelShow()"
  >
    <template #modal-title>
      <h2 class="m-0">Evacuation Diagram Edit</h2>
    </template>
    <validation-observer ref="editUserFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <b-form-group label-for="site">
          <template #label>
            Site <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="site"
            placeholder="Select Site"
            :options="sites"
            autoscroll
            :clearable="true"
            @input="fetchBuildings()"
            required
            disabled
          ></v-select>
        </b-form-group>


        <b-form-group label-for="building">
          <template #label>
            Building <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="building"
            placeholder="Select Site"
            :options="buildings"
            autoscroll
            :clearable="true"
            @input="fetchFloors()"
            required
            disabled
          ></v-select>
        </b-form-group>

        <b-form-group label-for="floor">
          <template #label>
            Floor <span class="text-danger">*</span>
          </template>
          <v-select
            label="floor_no"
            v-model="floor"
            placeholder="Select Floor"
            :options="floors"
            autoscroll
            :clearable="true"
            required
            disabled
          ></v-select>
        </b-form-group>


        <b-form-group label-for="installation_date">
          <template #label>
            Installation Date <span class="text-danger">*</span>
          </template>
          <b-form-datepicker id="installation_date" v-model="installation_date" class="mb-2"></b-form-datepicker>
        </b-form-group>


        <b-form-group label-for="expiry_date">
          <template #label>
            Expiry Date <span class="text-danger">*</span>
          </template>
          <b-form-datepicker id="expiry_date" v-model="expiry_date" class="mb-2"></b-form-datepicker>
        </b-form-group>


        <validation-provider
          #default="{ errors }"
          name="DisplayImage"
          rules="required"
        >
          <b-form-group
            class="form-group"
            id="input-group-2"
            label="Evacuation Diagram:"
            label-for="input-2"
            description="Upload an Evacuation Diagram in PNG, JPG, JPEG or PDF format."
          >
            <b-form-file
              ref="displayImageInput"
              id="displayDocuments"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              required
              accept=".png,.jpg,.jpeg,.pdf"
              plain
              v-model="evacuation_diagram"
            ></b-form-file>

            <p class="error">{{ errors[0] }}</p>
          </b-form-group>
        </validation-provider>

        

       

        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Save
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  props: { evacuation_diagram_data : Object, },
  data() {
    return {
      required,
      name: "",
      regex: /^[a-zA-Z ]*$/,
      site: null,
      building: null,
      floor: null,
      sites: [],
      buildings: [],
      floors : [],
      expiry_date: "",
      installation_date: "",
      evacuation_diagram: null,      
    };
  },
  methods: {
    ...mapActions({
      updateEvacuationDiagram: "appData/updateEvacuationDiagram",
      getFloorsDDL: "appData/getFloorsDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getSitesDDL: "appData/getSitesDDL",
    }),

    async submit() {
      try {
        const formData = new FormData();
        formData.append("installation_date", this.installation_date);
        formData.append("expiry_date", this.expiry_date);
        if(this.evacuation_diagram)
        {
          formData.append("evacuation_diagram", this.evacuation_diagram);
        }
        formData.append("updated_by", this.getLoggedInUser.id);
        const res = await this.updateEvacuationDiagram({
          payload: formData,
          pk: this.evacuation_diagram_data.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Evacuation Diagram Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("edit-evacuation-diagram-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    validateFileType(event, fileType) {
      const file = event.target.files[0];
      if (!file) return;

      if (fileType === 'evacuation_diagram') {
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
          event.target.value = null;
          if (this.$refs.displayImageInput) {
            this.$refs.displayImageInput.$el.setCustomValidity('Please upload a PNG, JPG, or JPEG image file.');
            this.$refs.displayImageInput.$el.reportValidity();
          }
        } else {
          if (this.$refs.displayImageInput) {
            this.$refs.displayImageInput.$el.setCustomValidity('');
          }
        }
      }
    },

    async fetchBuildings(){
      const buildings =  await this.getBuildingsDDL();
      this.buildings = buildings.data;
      this.building = "";
      this.floor = "";
       if (!this.site) {
        this.building = [];
        return;
      }
      this.buildings = this.buildings.filter(building => building.site === this.site.id);      
    },

    async fetchFloors(){
      const floors =  await this.getFloorsDDL();
      this.floors = floors.data;
      this.floor = "";
       if (!this.building) {
        this.floors = [];
        return;
      }
      this.floors = this.floors.filter(floor => floor.building === this.building.id);   

    },

    reset() {
      this.name = "";
      this.location = "";
      this.description = "";
      this.files = null;
      this.status = "";
    },
    async modelShow()
    {
      

      if(this.evacuation_diagram_data){
        this.site = this.sites.find(s => s.id === this.evacuation_diagram_data.site);
        this.building = this.buildings.find(b => b.id === this.evacuation_diagram_data.building);
        this.floor = this.floors.find(floor => floor.id === this.evacuation_diagram_data.floor);
        this.installation_date = this.evacuation_diagram_data.installation_date;
        this.expiry_date = this.evacuation_diagram_data.expiry_date;
      }
    }
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  async mounted(){
    const sites =  await this.getSitesDDL();
      this.sites = sites.data;

      const buildings =  await this.getBuildingsDDL();
      this.buildings = buildings.data;
      
      const floors =  await this.getFloorsDDL();
      this.floors = floors.data;
  }
  
};
</script>

<style></style>
